export default [
    { id: 'MovementEnquiryDetails', label: 'Movement Details', parent: '' },
    { id: 'Transactions', label: 'Transactions', parent: '' },
    { id: 'BinLocations', label: 'Bin Locations', parent: '' },
    { id: 'LotDetails', label: 'Lot Details', parent: 'Lines' },
    { id: 'SerialNumbers', label: 'Serial Numbers', parent: '' }
];
